<template>
  <div :class="props.class">
    <div class="ai-sceleton"></div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';

const props = defineProps({
  class: {
    type: String as PropType<string>,
  },
});
</script>

<style scoped lang="scss" src="./AiSceleton.scss" />
